import React from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import TEXT from "../../../utils/text/pnudBook.json";
import SurveyGraphSection from "../../reusable/SurveyGraphSection/SurveyGraphSection";
import createPNUDTitle from "../../../utils/functions/createPNUDTitle";
import DATA from "../../../utils/PNUD/economic.json";
import CardSurveys from "../../reusable/CardSurveys";
import { TOOLTIP_STYLE } from "../../../utils/constants/graphConfigs";
import { formatNumber } from "../../../utils/functions/formatNumber";
import { getCountryName } from "../../../utils/constants/nameCountry";

export default function PNUDEconomicContribution({ textPlacement }) {
  const { language } = useCurrentLanguage();

  function EconomicGraph() {
    DATA["indicator"].forEach((e) => {
      e.name = getCountryName(e.code, language, true);
    });

    const options = {
      color: ["#253c59", "#bf8d30"],
      backgroundColor: "transparent",
      tooltip: {
        ...TOOLTIP_STYLE,
        trigger: "item",
        valueFormatter: (value) => formatNumber(value) + "pp",
        formatter: (props) => {
          let content = "<div>";
          content += "<h4>" + props.name + "</h4>";

          let marker;
          for (let i = 0; i < DATA["indicator"].length; i++) {
            marker = props.marker;
            content +=
              "<div>" +
              props.marker +
              " " +
              getCountryName(DATA.indicator[i].code, language, true) +
              " " +
              props.value[i] +
              "pp</div>";
          }

          DATA.missingCountries.forEach((e) => {
            content +=
              "<div>" +
              marker +
              " " +
              getCountryName(e, language, true) +
              ": 0pp</div>";
          });
          content += "</div>";
          return content;
        },
      },
      legend: {
        data: [
          TEXT["economicContribution"]["informative"][language],
          TEXT["economicContribution"]["emotive"][language],
        ]
      },
      radar: {
        indicator: DATA["indicator"],
        center: ["50%", "60%"]
      },
      series: [
        {
          type: "radar",
          data: [
            {
              value: DATA["informativeData"],
              name: TEXT["economicContribution"]["informative"][language],
            },
            {
              value: DATA["emotiveData"],
              name: TEXT["economicContribution"]["emotive"][language],
            },
          ],
          areaStyle: {},
          top: 100
        },
      ],
    };

    return (
      <>
        <div className="pnud-graph-content">
          <CardSurveys options={options} isGraphLeft={false} />
        </div>

        <div className="pnud-graph-note">{TEXT["notePP"][language]}</div>
      </>
    );
  }

  return (
    <SurveyGraphSection
      graphID={"pnud-acceptance"}
      textPlacement={textPlacement}
      title={createPNUDTitle(TEXT["economicContribution"]["title"], language)}
      description={TEXT["economicContribution"]["description"][language]}
      language={language}
      graphComponent={<EconomicGraph />}
      note={TEXT["economicContribution"]["note"][language]}
      source={TEXT["source"][language]}
    />
  );
}
